import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from './search.service';
import { UserService } from '../shared/user.service';
import { Subscription } from 'rxjs';
import { User } from '../shared/user.model';
import { AlternativeSearchesAvailable } from './models/alternativesearchesavailable.model';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {
  isLoading = false;
  loadingSubscription: Subscription;
  searchResultsSubscription: Subscription;
  altSearchCount: number = 0;
  user: User;
  userSubscription = new Subscription();
  constructor(private searchService: SearchService,private userService: UserService) { }
  ngOnInit() {
    this.userSubscription = this.userService.userChanged.subscribe(
      (user: User) => {
        this.user = user;
      }
    )
    this.loadingSubscription = this.searchService.isLoading.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
    this.searchResultsSubscription = this.searchService.alternativeSearchesAvailableChanged.subscribe((altSearches: AlternativeSearchesAvailable) => {
      this.altSearchCount = altSearches.getCount();
    });
  }
  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }
}
